import SideMenu from '@/containers/side-menu/SideMenu.vue';
const TariffPlan = () => import('@/pages/tariff-plan/TariffPlan.vue');

export default {
  path: '/tariff-plan',
  name: 'TariffPlan',
  components: {
    mainContent: TariffPlan,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'tariff-plan',
    },
    breadcrumb: {
      title: 'Serviço tarifário',
      paths: [{ title: 'Plano tarifário' }],
    },
  },
};
